import React from 'react';

const Latest = ({ btn, all, latestNews }) => {
    const navigateBlog = (url) => {
        window.open(window.location.origin + `${url}`, '_blank');
    }

    return (
        <div className={`${all ? 'my-10 ' : 'mx-1 hidden md:block'}`} id={`${all && 'all'}`}>
            <h2 className={` ${all ? 'text-slate-500 lg:text-3xl text-lg font-bold border-b-2 border-cyan-400 ' : 'bg-head text-white text-center text-lg rounded-sm cursor-pointer'}  p-2`}>Latest update</h2>
            {
                all ?
                    latestNews.map((l, index) => <div key={index} className=' m-2 py-5  hover:transition ease-in-out  pl-2 duration-300 cursor-pointer style grid lg:grid-cols-[10%_minmax(20%,_1fr)_65%] md:grid-cols-[20%_minmax(30%,_1fr)_45%] gap-4 font-medium' onClick={() => navigateBlog(l.url)}>
                        <span>Date: {l.date}</span>
                        <span className=''>{l.title}</span>
                        <span>{l.paragraph}</span>
                    </div>)
                    :

                    latestNews.slice(0, 4).map((l, index) => <div key={index} className=' p-1  m-1'>
                        <p className=' border-b-2 border-[#EAE7DC] md:py-2 lg:py-3 xl:py-4 hover:text-white hover:bg-slate-300 hover:transition ease-in-out  duration-300 cursor-pointer px-1' onClick={() => navigateBlog(l.url)}>
                            <p>Date: {l.date}</p>
                            <p>{l.title}</p>
                        </p>
                    </div>)

            }
            {
                all ?
                    <a href="#"><button className=' bg-cyan-600 rounded p-1 mt-1 text-white w-full'>{btn}</button></a>
                    :
                    <a href="#all"><button className=' bg-cyan-600 rounded p-1 mt-1 text-white w-full'>{btn}</button></a>
            }


        </div>
    );
};

export default Latest;